// chill-cursor: soft sage halo + ✦ trail following the cursor.
//
// Desktop only (fine-pointer): follows pointer with ✦ trail.
// Mobile: disabled — finger is already visible, and DOM mutations during
//   touchstart caused iOS Safari to drop subsequent click events on footer
//   links (pointer-events:none on body pseudo-elements has a known iOS bug).
// Shared: --chill-cursor-x/--chill-cursor-y CSS vars on body drive the halo.
//
// Spec: docs/MASTER-BRIEF.md §6 Law 1 (Soft Depth), brand DNA polish
// Budget: < 1 KB gzip. No deps.

(function () {
  'use strict';

  if (window.chillandoutCursorLoaded) return;
  window.chillandoutCursorLoaded = true;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const TRAIL_INTERVAL_MS = 90;
  const TRAIL_LIFE_MS     = 800;
  const IDLE_HIDE_MS      = 1400;
  const SPAWN_DRIFT_PX    = 6;

  let lastTrail = 0;
  let idleTimer = 0;

  function activate() {
    document.body.dataset.chillCursorActive  = 'true';
    document.body.dataset.chillCursorVisible = 'true';
  }

  function setIdle() {
    document.body.dataset.chillCursorVisible = 'false';
  }

  function setPosition(x, y) {
    document.body.style.setProperty('--chill-cursor-x', x + 'px');
    document.body.style.setProperty('--chill-cursor-y', y + 'px');
    document.body.dataset.chillCursorVisible = 'true';
  }

  function spawnTrail(x, y) {
    const span = document.createElement('span');
    span.className = 'chill-cursor-trail';
    span.textContent = '✦';
    span.setAttribute('aria-hidden', 'true');
    const dx = (Math.random() - 0.5) * SPAWN_DRIFT_PX;
    const dy = (Math.random() - 0.5) * SPAWN_DRIFT_PX;
    span.style.left = (x + dx) + 'px';
    span.style.top  = (y + dy) + 'px';
    document.body.appendChild(span);
    setTimeout(() => span.remove(), TRAIL_LIFE_MS);
  }

  function scheduleIdle() {
    if (idleTimer) clearTimeout(idleTimer);
    idleTimer = setTimeout(setIdle, IDLE_HIDE_MS);
  }

  /* ── Desktop pointer ── */
  const isFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (isFinePointer) {
    function onMove(e) {
      setPosition(e.clientX, e.clientY);
      const now = performance.now();
      if (now - lastTrail >= TRAIL_INTERVAL_MS) {
        spawnTrail(e.clientX, e.clientY);
        lastTrail = now;
      }
      scheduleIdle();
    }

    function onFirstMove(e) {
      activate();
      document.removeEventListener('pointermove', onFirstMove);
      document.addEventListener('pointermove', onMove, { passive: true });
      onMove(e);
    }

    document.addEventListener('pointermove', onFirstMove, { passive: true });
    document.addEventListener('pointerleave', setIdle);
    document.addEventListener('pointerout', (e) => { if (!e.relatedTarget) setIdle(); });
  }

})();
